export default function SharedWorker_fn() {
  return new SharedWorker(__webpack_public_path__ + "js/event-worker.def76694.worker.js");
}
